<script setup lang="ts">
import type { ReferenceItem } from '@/components/references/ReferenceListItem.vue';
import ReferencesPanel from '@/components/references/ReferencesPanel.vue';

export type Reference = ReferenceItem;

defineProps<{
    references: ReferenceItem[];
    citedIds?: ReadonlySet<string>;
    collections?: string[];
}>();

const emit = defineEmits<{
    cite: [ref: ReferenceItem];
}>();
</script>

<template>
    <ReferencesPanel
        :references="references"
        density="compact"
        :cited-ids="citedIds"
        :collections="collections"
        @cite="emit('cite', $event)"
    />
</template>
